import React from "react";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import { getFormatedBusinessDate } from "../../../../../utils/Functions/table";
import useOfferDetails from "./useOfferDetails";

const money = (value) =>
  value === undefined || value === null
    ? "-"
    : `KD ${Number(value).toFixed(3)}`;

// The dashboard's one date shape, rather than this dialog's own reading of an ISO string.
// Still a dash when there is nothing to show, which is this dialog's habit.
const day = (value) => getFormatedBusinessDate(value) || "-";

const OfferDetails = ({ offerId, handleClose }) => {
  const { offer, isFetching, isExporting, handleExportCodes } =
    useOfferDetails(offerId);

  if (isFetching) {
    return <p className="pro-mb-0">Loading…</p>;
  }

  const redemptions = offer?.redemptions ?? [];

  return (
    <div>
      <div className="pro-d-flex pro-justify-between pro-items-center pro-mb-4">
        <div>
          <h5 className="pro-ttl pro-mb-1">{offer?.offer_code}</h5>
          <p className="pro-font-sm pro-mb-0">
            {offer?.organisation} — {offer?.plan_name}
          </p>
        </div>
        {/* Only a unique-codes offer has a code pool to hand over. */}
        {offer?.code_type === "unique" && (
          <Button
            className={"pro-btn-outline lg"}
            onClick={handleExportCodes}
            disabled={isExporting}
          >
            {isExporting ? "Exporting…" : "Export Codes"}
          </Button>
        )}
      </div>

      <div className="row pro-mb-4">
        <div className="col-6 pro-mb-2">
          <span className="pro-font-sm">Status</span>
          <p className="pro-mb-0 pro-fw-medium pro-text-capitalize">
            {String(offer?.status_label ?? "").replace("_", " ")}
          </p>
        </div>
        <div className="col-6 pro-mb-2">
          <span className="pro-font-sm">Type</span>
          <p className="pro-mb-0 pro-fw-medium pro-text-capitalize">
            {offer?.offer_type}
            {offer?.offer_type === "discounted"
              ? ` (${offer?.discount_percent}%)`
              : ""}
          </p>
        </div>
        <div className="col-6 pro-mb-2">
          <span className="pro-font-sm">Seats</span>
          <p className="pro-mb-0 pro-fw-medium">
            {offer?.used_seats} used · {offer?.seats_remaining} left of{" "}
            {offer?.seats}
          </p>
        </div>
        <div className="col-6 pro-mb-2">
          <span className="pro-font-sm">Window</span>
          <p className="pro-mb-0 pro-fw-medium">
            {day(offer?.code_valid_from)} — {day(offer?.code_valid_to)}
          </p>
        </div>
        <div className="col-6 pro-mb-2">
          <span className="pro-font-sm">Seat value</span>
          <p className="pro-mb-0 pro-fw-medium">{money(offer?.seat_value)}</p>
        </div>
        <div className="col-6 pro-mb-2">
          <span className="pro-font-sm">Maximum liability</span>
          <p className="pro-mb-0 pro-fw-medium">{money(offer?.max_liability)}</p>
        </div>
        <div className="col-6 pro-mb-2">
          <span className="pro-font-sm">Employee pays</span>
          <p className="pro-mb-0 pro-fw-medium">
            {money(offer?.employee_price)}
          </p>
        </div>
        <div className="col-6 pro-mb-2">
          <span className="pro-font-sm">Validity per employee</span>
          <p className="pro-mb-0 pro-fw-medium">
            {offer?.plan_validity_days} days from redemption
          </p>
        </div>
      </div>

      <h6 className="pro-ttl pro-mb-2">
        Activated employees ({redemptions.length})
      </h6>
      {redemptions.length === 0 ? (
        <p className="pro-font-sm pro-mb-0">
          Nobody has redeemed this offer yet.
        </p>
      ) : (
        <div className="pro-table-wrapper pro-overflow-auto">
          <table className="pro-table">
            <thead>
              <tr>
                <th>Subscription</th>
                <th>Code</th>
                <th>Activated</th>
                <th>Expires</th>
                <th>Redeemed</th>
                <th>Remaining</th>
              </tr>
            </thead>
            <tbody>
              {redemptions.map((item) => (
                <tr key={item?.subscription_id}>
                  <td>{item?.subscription_code}</td>
                  <td>{item?.corporate_code}</td>
                  <td>{day(item?.activated_at)}</td>
                  <td>{day(item?.expires_at)}</td>
                  <td>
                    {item?.redeemed_items} / {item?.total_items}
                  </td>
                  <td>{item?.remaining_items}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="pro-d-flex pro-justify-end pro-mt-4">
        <Button className={"pro-btn-link lg"} onClick={handleClose}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default OfferDetails;
